import ApiService from './ApiService';

class SettlementService {
  async debitSettlement(payload = {}) {
    try {
      const response = await ApiService.call('/secured/perform_debit_settlement', 'POST', payload);
      let data = response;

      console.log(data);

      return {
        tradingAccountIds: data.tradingAccountIds,
        totalDebitAmount: data.totalDebitAmount,
        success: true,
        message: 'Settlement successfull!',
      };
    } catch (error) {
      let data = error.response.data;
      return {
        success: false,
        code: data.error,
        message: data.message,
      };
    }
  }

  async creditSettlement(payload = {}) {
    try {
      const response = await ApiService.call('/secured/perform_credit_settlement', 'POST', payload);
      let data = response;

      return {
        tradingAccountIds: data.tradingAccountIds,
        totalCreditAmount: data.totalCreditAmount,
        success: true,
        message: 'Settlement successfull!',
      };
    } catch (error) {
      let data = error.response.data;
      return {
        success: false,
        code: data.error,
        message: data.message,
      };
    }
  }

  async getPendingSettlement() {
    try {
      const response = await ApiService.call('/secured/get_pending_settlement_list', 'GET');
      let data = response;

      console.log(data);

      return {
        settlementId: data.settlementId,
        settlementWindow: data.settlementWindow,
        settlementStage: data.settlementStage,
        tradeWindow: data.tradeWindow,
        creditAmount: data.creditAmount,
        success: true,
        message: 'Settlement successfull!',
      };
    } catch (error) {
      let data = error.response.data;
      return {
        success: false,
        code: data.error,
        message: data.message,
      };
    }
  }

  async performSettlementMatching(payload) {
    try {
      const response = await ApiService.call(
        '/secured/perform_settlement_matching_process',
        'POST',
        payload,
      );

      return {
        data: response,
        success: true,
        // message: 'Settlement successfull!',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async performSettlement(payload) {
    try {
      const response = await ApiService.call(
        '/secured/perform_settlement_process',
        'POST',
        payload,
      );
      let data = response;

      console.log(data);

      return {
        data: response,
        success: true,
        message: 'Settlement successfull!',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}

export default new SettlementService();
